import cx from 'classnames';

const DEFAULT_CLASS = 'react-tabs__tab-panel';

const defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: `${DEFAULT_CLASS}--selected`
};

const TabPanel = (props) => {
  const {
    children,
    className,
    forceRender,
    id,
    selected,
    selectedClassName,
    ...attributes
  } = props;

  return (
    <div
      {...attributes}
      className={cx(className, {
        [selectedClassName]: selected
      })}
      role="tabpanel"
      id={`panel${id}`}
      aria-labelledby={`tab${id}`}
    >
      {forceRender || selected ? children : null}
    </div>
  );
};

TabPanel.defaultProps = defaultProps;
TabPanel.tabsRole = 'TabPanel';
export default TabPanel;
